import { RuntimeProfileScreen } from '@/features/unified-learning/runtime/screens/RuntimeProfileScreen';

export default function LearnPathProfileRoute() {
  return <RuntimeProfileScreen runtimeBase="/learn/path" />;
}
